import request from "../request";
import Url from "../url/main";

const getUserList = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getUserList + path, data, options);
};

const getQuestionnaireData1List = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getQuestionnaireData1List + path, data, options);
};
const getQuestionnaireData1Details = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(Url.getQuestionnaireData1Details + path, data, options);
};
const getQuestionnaireData2List = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getQuestionnaireData2List + path, data, options);
};
const getQuestionnaireData2Details = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(Url.getQuestionnaireData2Details + path, data, options);
};
const getQuestionnaireData3List = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getQuestionnaireData3List + path, data, options);
};
const getQuestionnaireData3Details = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(Url.getQuestionnaireData3Details + path, data, options);
};

export default {
  getUserList,

  getQuestionnaireData1List,
  getQuestionnaireData1Details,
  getQuestionnaireData2List,
  getQuestionnaireData2Details,
  getQuestionnaireData3List,
  getQuestionnaireData3Details,
};
